<template>
  <section class="cooperaDetailDiv">
    <section class="viewTitle">
      <viewTitle
        title="业务管理 / 合作单位管理 / 查看单位详情"
        :showReturn="true"
      />
    </section>

    <section class="main">
      <el-form label-width="150px" label-position="left">
        <!-- <el-row> -->
        <el-form-item label="单位类别：">
          {{ rowDataObj.class_name || "--" }}
        </el-form-item>
        <el-form-item label="单位全称：">
          {{ rowDataObj.full_name || "--" }}
        </el-form-item>
        <el-form-item label="单位简称：">
          {{ rowDataObj.short_name || "--" }}
        </el-form-item>
        <el-form-item label="统一社会公信代码：">
          {{ rowDataObj.unified_social_credit_code || "--" }}
        </el-form-item>
        <el-form-item label="营业执照扫描件：">
          <el-image
            class="cardimg"
            :src="scanUrl"
            :preview-src-list="srcList"
            v-if="scanUrl"
          >
          </el-image>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="单位规模：">
          {{
            rowDataObj.unit_size === 0 || rowDataObj.unit_size === ""
              ? "--"
              : unitScaleOptions[rowDataObj.unit_size - 1]
          }}
        </el-form-item>
        <el-form-item label="经营范围：">
          {{ rowDataObj.business_scope || "--" }}
        </el-form-item>
        <el-form-item label="主要联系人：">
          {{ rowDataObj.contact || "--" }}
        </el-form-item>
        <el-form-item label="手机号码：">
          {{ rowDataObj.phone || "--" }}
        </el-form-item>
        <el-form-item label="可用业务：">
          <div v-for="(item, index) in params.include" :key="index">
            {{ item.name || "--" }}
            <span v-if="item.arr.length > 0">
              （{{ item.arr.join("、") }}）</span
            >
          </div>
        </el-form-item>
        <el-form-item label="启用企业微信：">
          <div v-if="rowDataObj.is_open_wx_work === 0" class="color67">
            禁用
          </div>
          <div v-else-if="rowDataObj.is_open_wx_work === 1">
            <span class="color5E">启用</span>
            <div v-if="listSuperAdmin.org.length > 0">
              部门：
              <span
                v-for="(item, index) in listSuperAdmin.org"
                :key="index"
                style="display: inline-block;"
              >
                {{ item.name }}
                <span v-if="index !== listSuperAdmin.org.length - 1">、</span>
              </span>
            </div>
            <div v-if="listSuperAdmin.group.length > 0">
              分组：
              <span
                v-for="(item, index) in listSuperAdmin.group"
                :key="index"
                style="display: inline-block;"
              >
                {{ item.name }}
                <span v-if="index !== listSuperAdmin.group.length - 1">、</span>
              </span>
            </div>
            <div v-if="listSuperAdmin.user.length > 0">
              人员：
              <span
                v-for="(item, index) in listSuperAdmin.user"
                :key="index"
                style="display: inline-block;"
              >
                {{ item.name }}
                <span v-if="index !== listSuperAdmin.user.length - 1">、</span>
              </span>
            </div>
          </div>
          <div v-else>--</div>
        </el-form-item>
        <el-form-item label="备注：">
          {{ rowDataObj.note || "--" }}
        </el-form-item>
        <el-form-item label="当前状态：">
          <span v-if="rowDataObj.state === 1" class="color5E">正常</span>
          <span v-else-if="rowDataObj.state === 2" class="color67">禁用</span>
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="创建日期：">
          {{ formatTime(rowDataObj.create_time) }}
        </el-form-item>
        <el-form-item label="最后更新日期：">
          {{ formatTime(rowDataObj.update_time) }}
        </el-form-item>
        <!-- </el-row> -->
      </el-form>
      <div style="margin: 30px 0px 0px;">
        <el-button
          size="small"
          type="primary"
          @click="
            $router.push({
              path: '/rhqy/service/coopera/List/modify',
              query: {
                type: 'edit',
                id: rowDataObj.id
              }
            })
          "
          >编 辑</el-button
        >
        <el-button type="primary" @click="passWord" size="small">
          密码管理
        </el-button>
        <el-button
          size="small"
          type="warning"
          style="color: white;"
          @click="moveUp('forbid')"
          v-if="rowDataObj.state === 1"
        >
          禁 用
        </el-button>
        <el-button
          size="small"
          type="warning"
          style="color: white;"
          @click="moveUp('start')"
          v-if="rowDataObj.state === 2"
        >
          启 用
        </el-button>
        <el-button
          type="danger"
          style="color: white;"
          @click="moveUp('del')"
          size="small"
        >
          删 除
        </el-button>
        <!-- <el-button
          @click="
            $router.push({
              path: '/rhqy/service/coopera/List'
            })
          "
          >返 回</el-button
        > -->
      </div>
    </section>
    <!-- 密码管理 -->
    <el-dialog
      :visible.sync="dialogParams.dialogPassShow"
      width="30%"
      title="密码管理"
    >
      <div>
        <el-form label-width="85px">
          <el-form-item label="单位类别：">
            {{ rowDataObj.class_name }}
          </el-form-item>
          <el-form-item label="当前单位：">
            {{ rowDataObj.full_name }}
          </el-form-item>
          <el-form-item label="企业账号：">
            {{ rowDataObj.phone }}
          </el-form-item>
          <el-form-item label="登录密码：">
            <span class="color99" v-if="rowDataObj.password === ''">
              用户已修改密码
            </span>
            <div v-else>
              <el-input
                v-model="dialogParams.pwd"
                style="width: 200px;margin-right: 25px;"
                readonly
                id="copyBoard"
              ></el-input>
              <el-button type="primary" @click="copyPassword" size="small">
                复 制
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.dialogPassShow = false" size="small">
          取 消
        </el-button>
        <el-button
          size="small"
          type="warning"
          @click="dialogParams.dialogResetPassShow = true"
          style="color: white;"
        >
          重置密码
        </el-button>
      </span>
      <el-dialog
        width="30%"
        title="确认提醒"
        :visible.sync="dialogParams.dialogResetPassShow"
        append-to-body
      >
        <span
          >确认要重置“<span class="color67">{{ rowDataObj.full_name }}</span
          >”的供应商登录密码吗？<br />重置后<span class="color67"
            >原有密码将立即失效</span
          >！</span
        >
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogParams.dialogResetPassShow = false"
            size="small"
          >
            取 消
          </el-button>
          <el-button type="primary" @click="confirmReset" size="small">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </el-dialog>

    <!-- 禁用  删除 -->
    <el-dialog :visible.sync="dialogParams.dialogMoveUpShow" width="30%">
      <template slot="title">
        <div style="font-size: 18px;">
          <i
            class="el-icon-success"
            style="color: #2acdcf;"
            v-if="dialogParams.title === '操作成功'"
          ></i>
          {{ dialogParams.title }}
        </div>
      </template>
      <div>
        <div v-html="dialogMoveUpContent"></div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="dialogParams.title === '确认提醒'"
      >
        <el-button @click="dialogParams.dialogMoveUpShow = false" size="small">
          取 消
        </el-button>
        <el-button
          size="small"
          type="danger"
          @click="confirmMoveUp"
          v-loading.fullscreen.lock="fullscreenLoading"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
import viewTitle from "@/components/viewTitle";
import mixinOrgUrl from "@/components/qyDept/mixinOrgUrl.js";

export default {
  data() {
    return {
      value: "",
      params: {
        unitTypeValue: 0, // 单位类别
        unitName: "", // 单位全称
        unitSimpleName: "", // 单位简称
        creditCode: "", // 统一社会信用代码
        scanPhotoUrl: "", // 营业执照扫描件
        unitScaleValue: "", // 单位规模
        scope: "", // 经营范围
        link: "", // 主要联系人
        phone: "", // 手机号码
        include: [] // 可用业务
      },
      unitScaleOptions: [
        "1-30人",
        "31-50人",
        "51-100人",
        "101-200人",
        "201-500人",
        "501-1000人",
        "1001人及以上"
      ],
      dialogParams: {
        title: "确认提醒",
        dialogMoveUpShow: false, // 上移一位弹窗
        dialogType: "", // 弹窗类型
        dialogPassShow: false, // 密码弹窗显示
        dialogResetPassShow: false, // 重置密码确认弹窗显示
        dialogUploadShow: false, // 导入文件
        pwd: "" // 密码
      },
      fullscreenLoading: false,
      dialogMoveUpContent: "",
      scanUrl: "",
      srcList: [],
      rowDataObj: {},
      serviceOptions: [],
      listSuperAdmin: { org: [], group: [], user: [] }, // 人员选择器
      deptListObj: {
        title: "选择发送范围",
        model: "bothAll",
        visible: false,
        pluginResult: {
          select: { org: [], group: [], user: [] }
        },
        numberShowPhone: false
      },
      orgUrl: ""
    };
  },

  components: {
    viewTitle
  },

  mixins: [mixinOrgUrl],

  computed: {
    id() {
      return this.$route.query.id;
    }
  },

  async mounted() {
    this.orgUrl = await this.mixinOrgUrlSet();
    this.getUnitList();
    this.getDetail();
    this.getServiceList();
  },

  async activated() {},

  created() {},

  methods: {
    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 密码管理
    passWord() {
      this.dialogParams.pwd = this.rowDataObj.password;
      this.dialogParams.dialogPassShow = true;
    },

    // 复制密码
    copyPassword() {
      var text = document.getElementById("copyBoard");
      text.select(); // 选择对象
      document.execCommand("Copy");
      this.$message.success("已复制密码到剪切板!");
    },

    // 确认重置密码
    confirmReset() {
      this.$common
        .http({
          url: "/api/queue/admin/reset_password",
          data: {
            id: this.rowDataObj.id
          }
        })
        .then(res => {
          console.log(res.data.data);
          if (res.data.data) {
            this.dialogParams.pwd = res.data.data;
            this.rowDataObj.password = res.data.data;
            setTimeout(() => {
              var text = document.getElementById("copyBoard");
              text.select(); // 选择对象
              document.execCommand("Copy");
              this.$common.pcToastSuccess("密码重置成功并已复制到粘贴板!");
            }, 1000);
          }
          this.dialogParams.dialogResetPassShow = false;
        });
    },

    // 获取单位类别列表
    async getUnitList() {
      await this.$common
        .http({
          url: "/api/queue/admin/query_unit_class",
          data: {
            state: 0,
            keyword: "",
            class_id: "",
            page_size: ""
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.unitOption = res.data.data.data;
        });
    },

    // 获取详情
    async getDetail() {
      await this.$common
        .http({
          url: "/api/queue/admin/query_unit_detail",
          data: {
            id: this.id
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.rowDataObj = res.data.data;
          // 扫描件
          if (this.rowDataObj.file) {
            this.scanUrl = this.rowDataObj.file.real_path;
            this.srcList.push(this.scanUrl);
          }
          // 业务
          if (this.rowDataObj.business) {
            for (let i = 0; i < this.rowDataObj.business.length; i++) {
              this.params.include.push({
                name: this.rowDataObj.business[i].com_name,
                arr: []
              });
              for (
                let j = 0;
                j < this.rowDataObj.business[i].business.length;
                j++
              ) {
                this.params.include[i].arr.push(
                  this.rowDataObj.business[i].business[j].name
                );
              }
            }
          }
          // 人员选择器
          this.$common
            .http({
              url: this.orgUrl.getInitData,
              data: {
                depts:
                  this.rowDataObj.dept_list !== ""
                    ? JSON.parse(this.rowDataObj.dept_list)
                    : "",
                users:
                  this.rowDataObj.user_list !== ""
                    ? JSON.parse(this.rowDataObj.user_list)
                    : "",
                tags: ""
              }
            })
            .then(res1 => {
              console.log(res1.data.data);
              let obj1 = res1.data.data;
              this.listSuperAdmin = {
                org: obj1.depts,
                group: obj1.tags,
                user: obj1.users
              };
              this.deptListObj.pluginResult.select = {
                org: obj1.depts,
                group: obj1.tags,
                user: obj1.users
              };
            });
        });
    },

    // 获取业务列表
    async getServiceList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_company",
        data: {}
      });
      let obj = dataObj.data.data;
      this.serviceOptions = obj;
    },

    // 禁用/删除
    moveUp(tag) {
      this.dialogParams.dialogType = tag;
      this.dialogParams.dialogMoveUpShow = true;
      this.dialogParams.title = "确认提醒";
      if (tag === "forbid") {
        this.dialogMoveUpContent = `确定要禁用“<span class="color67">${this.rowDataObj.full_name}</span>”的登录账户？<br />禁用后该单位不可登录，不可发起预约业务！`;
      } else if (tag === "start") {
        this.dialogMoveUpContent = `确定要启用“<span class="color67">${this.rowDataObj.full_name}</span>”的登录账户？`;
      } else if (tag === "del") {
        this.dialogMoveUpContent = `确定要删除“<span class="color67">${this.rowDataObj.full_name}</span>”的账户信息？<span class="color67">删除后不可恢复</span>！`;
      }
    },

    // 确认操作
    confirmMoveUp() {
      if (this.dialogParams.title === "确认提醒") {
        this.dialogParams.dialogMoveUpShow = false;
        let url = "";
        if (this.dialogParams.dialogType === "del") {
          url = "/api/queue/admin/del_unit";
        } else if (
          this.dialogParams.dialogType === "start" ||
          this.dialogParams.dialogType === "forbid"
        ) {
          url = "/api/queue/admin/enable_unit";
        }
        this.$common
          .http({
            url: url,
            data: {
              id: this.rowDataObj.id
            }
          })
          .then(res => {
            console.log(res);
            this.dialogMoveUpContent = `已成功删除“<span class="color67">${this.rowDataObj.full_name}</span>”的账户信息。`;
            if (this.dialogParams.dialogType === "del") {
              this.$common.pcToastSuccess(
                `已成功删除“${this.rowDataObj.full_name}”的账户信息。`
              );
            } else if (this.dialogParams.dialogType === "forbid") {
              this.rowDataObj.state = 2;
              this.$common.pcToastSuccess(
                `已成功禁用“${this.rowDataObj.full_name}”的账户信息。`
              );
            } else if (this.dialogParams.dialogType === "start") {
              this.rowDataObj.state = 1;
              this.$common.pcToastSuccess(
                `已成功启用“${this.rowDataObj.full_name}”的账户信息。`
              );
            }
            // this.dialogParams.dialogMoveUpShow = true;
            // this.dialogParams.title = "操作成功";
            setTimeout(() => {
              // this.dialogParams.dialogMoveUpShow = false;
              if (this.dialogParams.dialogType === "del") {
                this.$router.push({
                  path: "/rhqy/service/coopera/List"
                });
              }
            }, 1500);
          });
      } else {
        this.dialogParams.dialogMoveUpShow = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.cooperaDetailDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // padding: 20px;
  overflow: auto;
  .main {
    font-size: 14px;
    line-height: 32px;
    padding: 16px;
  }
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  .introduce {
    color: red;
    line-height: 25px;
    margin: 0px 0px 16px;
    font-size: 14px;
  }
  // 头像
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 90px;
    line-height: 90px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 88px;
    height: 88px;
    line-height: 90px;
    text-align: center;
  }
  .cardimg {
    width: 80px;
    height: 80px;
    margin-top: 7px;
    margin-right: 17px;
  }
}
.el-form-item {
  margin-bottom: 0px;
}
</style>
<style lang="less">
.cooperaDetailDiv {
  .el-image__preview {
    object-fit: cover;
  }
}
</style>
